(() => {
  const ROTATE_MS = 2600;

  /* =========================
     CONFETTI SETTINGS
     ========================= */
  const CONFETTI = {
    colors: ["#04A196", "#FFFFFF"],
    minCount: 14,
    maxCount: 22,
    durationMs: 700,
    cooldownMs: 900
  };

  const STATE_KEY = "__DL_CART_GOALS_STATE__";

  /* =========================
     HELPERS
     ========================= */
  function isDrawerOpen() {
  const drawer = document.querySelector("cart-drawer.drawer");
  if (!drawer) return false;

  // Dawn 15+ sometimes toggles different classes
  if (drawer.classList.contains("active")) return true;

  // fallback: check if inner drawer is visible
  const inner = drawer.querySelector(".drawer__inner");
  if (inner && getComputedStyle(inner).visibility !== "hidden") return true;

  return false;
}

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function getState() {
    if (!window[STATE_KEY]) {
      window[STATE_KEY] = {
        reached: { 1: false, 2: false, 3: false },
        lastFire: { 1: 0, 2: 0, 3: 0 }
      };
    }
    return window[STATE_KEY];
  }

  function resetConfettiState() {
    if (window[STATE_KEY]) {
      window[STATE_KEY].reached = { 1: false, 2: false, 3: false };
      window[STATE_KEY].lastFire = { 1: 0, 2: 0, 3: 0 };
    }
  }

  function now() {
    return (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  }

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  /* =========================
     CONFETTI QUEUE (prevents overlap)
     ========================= */
  const CONFETTI_QUEUE = [];
  let CONFETTI_RUNNING = false;

  function enqueueConfetti(job) {
    CONFETTI_QUEUE.push(job);

    if (CONFETTI_RUNNING) return;

    CONFETTI_RUNNING = true;

    (function runNext() {
      const next = CONFETTI_QUEUE.shift();

      if (!next) {
        CONFETTI_RUNNING = false;
        return;
      }

      next(() => {
        setTimeout(runNext, 140);
      });
    })();
  }

  /* =========================
     CANVAS OVERLAY (persistent)
     ========================= */
  function createOverlayCanvas() {
    let canvas = document.querySelector("canvas[data-cart-goals-confetti='1']");

    if (!canvas) {
      canvas = document.createElement("canvas");
      canvas.setAttribute("data-cart-goals-confetti", "1");
      canvas.style.position = "fixed";
      canvas.style.left = "0";
      canvas.style.top = "0";
      canvas.style.width = "100vw";
      canvas.style.height = "100vh";
      canvas.style.pointerEvents = "none";
      canvas.style.zIndex = "2147483646";
      document.body.appendChild(canvas);
    }

    const ctx = canvas.getContext("2d");

    function resize() {
      const dpr = window.devicePixelRatio || 1;
      canvas.width = Math.floor(window.innerWidth * dpr);
      canvas.height = Math.floor(window.innerHeight * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resize();

    const onResize = () => resize();
    window.addEventListener("resize", onResize, { passive: true });

    return {
      canvas,
      ctx,
      destroy() {
        window.removeEventListener("resize", onResize);
        // canvas stays alive for reuse
      }
    };
  }

  function fireConfettiFromElement(el, done) {
    if (!isDrawerOpen()) return done?.();
    if (prefersReducedMotion()) return done?.();

    const rect = el.getBoundingClientRect();
    const originX = rect.left + rect.width * 0.5;
    const originY = rect.top + rect.height * 0.25;

    const overlay = createOverlayCanvas();
    const { ctx } = overlay;

    const count = Math.floor(rand(CONFETTI.minCount, CONFETTI.maxCount + 1));
    const particles = [];

    for (let i = 0; i < count; i++) {
      const angle = rand(-Math.PI * 0.85, -Math.PI * 0.15);
      const speed = rand(3.2, 5.6);
      const size = rand(4.5, 8.0);

      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        g: rand(0.07, 0.12),
        size,
        rot: rand(0, Math.PI * 2),
        vr: rand(-0.2, 0.2),
        color: pick(CONFETTI.colors),
        shape: Math.random() > 0.5 ? "rect" : "circle"
      });
    }

    const start = now();

    function frame(t) {
      const elapsed = t - start;
      const p = Math.min(1, elapsed / CONFETTI.durationMs);
      const alpha = 1 - p;

      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      for (const part of particles) {
        part.vy += part.g;
        part.x += part.vx;
        part.y += part.vy;
        part.rot += part.vr;

        ctx.save();
        ctx.globalAlpha = Math.max(0, alpha);
        ctx.translate(part.x, part.y);
        ctx.rotate(part.rot);
        ctx.fillStyle = part.color;

        if (part.shape === "circle") {
          ctx.beginPath();
          ctx.arc(0, 0, part.size * 0.55, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-part.size / 2, -part.size / 2, part.size, part.size * 0.75);
        }

        ctx.restore();
      }

      if (elapsed < CONFETTI.durationMs) {
        requestAnimationFrame(frame);
      } else {
        done?.();
      }
    }

    requestAnimationFrame(frame);
  }

  /* =========================
     CONFETTI TRIGGER LOGIC (stable)
     ========================= */
  function maybeConfetti(elRoot, goalIndex, reachedNow) {
    const state = getState();

    if (!isDrawerOpen()) return;
    if (prefersReducedMotion()) return;

    const wasReached = !!state.reached[goalIndex];

    // if user falls below, reset so it can fire again later
    if (!reachedNow) {
      state.reached[goalIndex] = false;
      return;
    }

    // reachedNow true
    const shouldFire = !wasReached;

    // update state after check
    state.reached[goalIndex] = true;

    if (!shouldFire) return;

    const t = now();
    const last = state.lastFire[goalIndex] || 0;
    if (t - last < CONFETTI.cooldownMs) return;
    state.lastFire[goalIndex] = t;

    enqueueConfetti((done) => {
      // Dawn rerender safe: reselect live from DOM
      const pillNow = document.querySelector(
        `[data-cart-goals] .cart-goals__milestone[data-goal="${goalIndex}"]`
      );

      if (!pillNow) return done();

      fireConfettiFromElement(pillNow, done);
    });
  }

  /* =========================
     EXISTING CODE
     ========================= */
  function formatMoneyFromCents(cents, currency = "EUR") {
    const value = (Math.max(0, cents) / 100);
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return `€${value.toFixed(2)}`;
    }
  }

  async function fetchCart() {
    const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });
    if (!res.ok) throw new Error("Failed to fetch cart.js");
    return await res.json();
  }

  function updateOne(el, cartTotalCents, currency = "EUR") {
    const goal1 = Number(el.dataset.goal1Cents || 5000);
    const goal2 = Number(el.dataset.goal2Cents || 8000);
    const goal3 = Number(el.dataset.goal3Cents || 10000);
    const max  = Number(el.dataset.maxCents || goal3 || 1);

    const pct = Math.min(100, Math.floor((cartTotalCents / max) * 100));
    const bar = el.querySelector(".cart-goals__bar");
    const fill = el.querySelector(".cart-goals__fill");
    if (bar) bar.setAttribute("aria-valuenow", String(pct));
    if (fill) fill.style.width = `${pct}%`;

    const reached1 = cartTotalCents >= goal1;
    const reached2 = cartTotalCents >= goal2;
    const reached3 = cartTotalCents >= goal3;

    const milestones = el.querySelectorAll(".cart-goals__milestone");
    milestones.forEach((m) => {
      const g = Number(m.getAttribute("data-goal"));
      const reached =
        (g === 1 && reached1) ||
        (g === 2 && reached2) ||
        (g === 3 && reached3);
      m.classList.toggle("is-reached", reached);
    });

    // ✅ Confetti per milestone
    maybeConfetti(el, 1, reached1);
    maybeConfetti(el, 2, reached2);
    maybeConfetti(el, 3, reached3);

    const msg1 = el.querySelector('[data-msg="1"]');
    const msg2 = el.querySelector('[data-msg="2"]');
    const msg3 = el.querySelector('[data-msg="3"]');

    const left1 = goal1 - cartTotalCents;
    const left2 = goal2 - cartTotalCents;
    const left3 = goal3 - cartTotalCents;

    const tAddShipping = el.dataset.textAddShipping || "Add {amount} to unlock free shipping.";
    const tAddGift     = el.dataset.textAddGift || "Add {amount} to unlock a mystery gift.";
    const tAddDiscount = el.dataset.textAddDiscount || "Add {amount} to unlock 10% off.";

    const tUnlockedShipping = el.dataset.textUnlockedShipping || "✅ Free shipping unlocked.";
    const tUnlockedGift     = el.dataset.textUnlockedGift || "✅ Mystery gift unlocked.";
    const tUnlockedDiscount = el.dataset.textUnlockedDiscount || "✅ 10% discount unlocked.";

    if (msg1) {
      msg1.textContent = reached1
        ? tUnlockedShipping
        : tAddShipping.replace("{amount}", formatMoneyFromCents(left1, currency));
    }
    if (msg2) {
      msg2.textContent = reached2
        ? tUnlockedGift
        : tAddGift.replace("{amount}", formatMoneyFromCents(left2, currency));
    }
    if (msg3) {
      msg3.textContent = reached3
        ? tUnlockedDiscount
        : tAddDiscount.replace("{amount}", formatMoneyFromCents(left3, currency));
    }
  }

  function initRotator(el) {
    if (el.__rotatorInit) return;
    el.__rotatorInit = true;

    const msgs = Array.from(el.querySelectorAll(".cart-goals__msg"));
    if (msgs.length <= 1) return;

    let i = 0;
    setInterval(() => {
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
    }, ROTATE_MS);
  }

  async function refreshAll() {
    const els = document.querySelectorAll("[data-cart-goals]");
    if (!els.length) return;

    try {
      const cart = await fetchCart();
      const total = Number(cart.total_price || 0);
      const currency = (cart.currency || "EUR");

      els.forEach((el) => {
        updateOne(el, total, currency);
        initRotator(el);
      });
    } catch (e) {
      // silent
    }
  }

  function bind() {
    refreshAll();

    // reset confetti state when drawer opens
    const setupDrawerObserver = () => {
      const drawer = document.querySelector("cart-drawer.drawer");
      if (!drawer) return false;

      let wasActive = drawer.classList.contains("active");

      const drawerObs = new MutationObserver(() => {
        const isActive = drawer.classList.contains("active");
        if (!wasActive && isActive) {
          resetConfettiState();
          refreshAll();
        }
        wasActive = isActive;
      });

      drawerObs.observe(drawer, { attributes: true, attributeFilter: ["class"] });
      return true;
    };

    if (!setupDrawerObserver()) {
      const onceObs = new MutationObserver(() => {
        if (setupDrawerObserver()) onceObs.disconnect();
      });
      onceObs.observe(document.body, { childList: true, subtree: true });
    }

    ["cart:updated", "cart:refresh", "cart:change", "cart:rerendered"].forEach((evt) => {
      document.addEventListener(evt, () => refreshAll());
    });

    document.addEventListener("click", (e) => {
      const withinCart = e.target.closest("cart-drawer, #CartDrawer, .drawer");
      if (!withinCart) return;

      const isQtyOrRemove =
        e.target.closest("button[name='plus'], button[name='minus'], a[href*='cart/change'], button[aria-label*='Remove'], button[name='remove']") ||
        e.target.matches("button[name='plus'], button[name='minus']");

      if (isQtyOrRemove) {
        setTimeout(refreshAll, 350);
      }
    });

    const obs = new MutationObserver(() => {
      refreshAll();
    });
    obs.observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();